<script>
import api from './../apiBridge'
import formatting from './../common/formatting.js'
import router from './../router';
import OrderHeader from './OrderHeader.vue';
import OrderItems from './OrderItems.vue';
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import {getQueryStringParameterByName, 
        checkFilterCriteria,
        idFullStory
       } from './../common/utils.js'

const DEFAULT_POLLING_INTERVAL = 20 * 1000;
const DISPLAY_LIMIT_FOR_PREP_SCREEN = 20;

export default {

  name: 'kds',

  components: {
    'orderheader': OrderHeader,
    'orderitems': OrderItems,
    'swiper': swiper,
    'slide': swiperSlide
  },

  props: {
    readyOrdersDisplay: {
      type: Boolean,
      default: false
    }
  },


  created: function () {
    // private data
  },


  methods: {

    checkLanguage() {
      if (!api.storeNumber) return;

      var self = this;
      var apiParameters = {};
      apiParameters.queryString = {};

      apiParameters.service = 'getIsEnglish';
      apiParameters.queryString['store_number'] = api.storeNumber;

      api.httpGet(apiParameters, function (response) {
        self.getOpenOrders();

        if (!response.data || response.data.error || response.status !=200 ) {
          // no language passed from Micros language injected from iOS if available
          api.setLanguage(window.config);
        } else {
          // set language
          api.language_flag = ''+response.status;

          console.log('Setting language from api: ' + response.data);

          if (response.data=='FR') {
            api.language = 'FR'
          } else {
            api.language = 'EN'
          }
        }

        self.$i18n.locale = api.language;
        self.$forceUpdate();

      });
    },
     
    getOpenOrders(resultCallback) {
      if (!api.storeNumber) return;
      if (this.pendingOrdersCall) return;

      console.log('Get open orders');

      var self = this;
      var apiParameters = {};
      apiParameters.queryString = {};

      apiParameters.service = 'getECommChecks';
      apiParameters.queryString['store_number'] = api.storeNumber;

      this.pendingOrdersCall = true;
      api.httpGet(apiParameters, function (response) {
        self.pendingOrdersCall = false;
        self.error = '';

        if (api.useOverride) {
          if (response.status !=200 ) { 
              self.error = self.$t('connection_error');
              return;            
          }
        } else if (!response.data || response.data.error || response.status !=200 ) {
          self.orderList = [];
          if (response.nativeError == 'no_data') {
            // continue - this just indicates there are no orders pending
          } else if (response.nativeError == 'connection_error') {
            self.error = 'ERR: ' + self.$t('connection_error');
            return;            
          } else if (response.errorMsg && response.errorMsg.response) {
            if (response.errorMsg.response.data && response.errorMsg.response.data.error == 'no_data') {
              // continue - this just indicates there are no orders pending
            } else {
              self.error = 'ERR: ' + self.$t('connection_error');
              return;
            }
          } else {
            self.error = 'ERR: ' + self.$t('no_internet');
            return;            
          }
        }

        self.processOrders(response.data);

        if (typeof resultCallback === "function") {
          resultCallback(response);
        }

      });
    },

    processOrders(orderListRaw) {
      let orderListNew = [];
      let orderItemsToUpdate = [];
      let inList = false;
      let newOrder = false;

      // timer is based on which board we are on:  Prep or Ready
      if (this.readyOrdersDisplay) {
        this.timeCheckField = 'readyTime';
      } else {
//        this.timeCheckField = 'last_update_tm';
        this.timeCheckField = 'chk_open_date_time';
      }

      // choose only the latest from duplicate orders
      if (orderListRaw && orderListRaw.length) {
        // set current time based on returned system time
        this.currentTime = (orderListRaw[0].checkdetails.Curr_DT)
                         ? formatting.dateFormat.dateFromStr(orderListRaw[0].checkdetails.Curr_DT)
                         : null;


        this.autoBumpCount = 0;
        // filter out any orders we shouldn't process
        orderListRaw = orderListRaw.filter(this.filterOutOrder);

        // filter out new order not already in list
        let pendingNewOrders = [];
        orderListRaw = orderListRaw.filter((order) => {
          if (this.orderItemsHash[''+order.checkdetails.chk_num]) {
            return true;
          } else {
            if (this.refreshDelay) {
              order.newOrder = true;
            }
            pendingNewOrders.push(order);
            return false;
          }
        });

        // default to existing sort index if orders already here
        orderListRaw.sort((a,b) => {
            if (this.orderItemsHash[''+a.checkdetails.chk_num] 
                      && this.orderItemsHash[''+b.checkdetails.chk_num]) {
              const indexa = this.orderItemsHash[''+a.checkdetails.chk_num].orderObject.sortIndex;
              const indexb = this.orderItemsHash[''+b.checkdetails.chk_num].orderObject.sortIndex;

              if (indexa > indexb)
                  return 1;
              if (indexa < indexb)
                  return -1;
              return 0;
            } 
        });
                        
        // sort new orders by datetime oldest to newest
        pendingNewOrders.sort((a,b) => {
              const dta = formatting.dateFormat.dateFromStr(a.checkdetails[this.timeCheckField]);
              const dtb = formatting.dateFormat.dateFromStr(b.checkdetails[this.timeCheckField]);

              if (dta > dtb)
                  return 1;
              if (dta < dtb)
                  return -1;
              return 0;
        });


        // add back new orders at the end of array
        orderListRaw = orderListRaw.concat(pendingNewOrders);

        // limit displayed orders on prep page for better performance
        const len = (!this.readyOrdersDisplay && orderListRaw.length > DISPLAY_LIMIT_FOR_PREP_SCREEN) 
                  ? DISPLAY_LIMIT_FOR_PREP_SCREEN 
                  : orderListRaw.length;


        for (let r=0; r < len; r++) {
          inList = false;
          for (let n=0; n < orderListNew.length; n++) {
            // replace any duplicate chk_nums with last record
            if (orderListRaw[r].checkdetails.chk_num == orderListNew[n].checkdetails.chk_num) {
              inList = true;
              if (orderListRaw[r].checkdetails.last_update_tm > orderListNew[n].checkdetails.last_update_tm
                  || orderListRaw[r].checkdetails.trans_seq > orderListNew[n].checkdetails.trans_seq) {
                orderListNew[n] = orderListRaw[r];
              }
            }
          }
          if (!inList && (!orderListRaw[r].checkdetails.autofire_time
                          || orderListRaw[r].checkdetails.autofire_time <= orderListRaw[r].checkdetails.Curr_DT)) {
            orderListNew.push(orderListRaw[r]);
          }
        }
      }

      // create a list of which orders need items updated based on last trans date comparison
      for (let n=0; n < orderListNew.length; n++) {
        if (this.orderList && this.orderList.length) {
          inList = false;
          for (let o=0; o < this.orderList.length; o++) {
            if (this.orderList[o].checkdetails.chk_num == orderListNew[n].checkdetails.chk_num) {
              inList = true;

              if (this.orderList[o].checkdetails.last_update_tm != orderListNew[n].checkdetails.last_update_tm
                  || this.orderList[o].checkdetails.trans_seq != orderListNew[n].checkdetails.trans_seq) {
                orderItemsToUpdate.push({
                    chk_num: this.orderList[o].checkdetails.chk_num,
                    existing: true
                });
              } else if (this.orderList[o].hidden) {
                // persist hidden orders if not updated
                orderListNew[n].hidden = true;
              } else {
                if (this.orderList[o].refId) {
                  // persist refId if not updated
                  orderListNew[n].refId = this.orderList[o].refId;
                }
                // persist post pay flag if not updated
                orderListNew[n].postPay = this.orderList[o].postPay || false;

                if (this.orderList[o].source) {
                  // persist status if not updated
                  orderListNew[n].source = this.orderList[o].source;
                }

              } 

            }
          }
          if (!inList) {
            orderItemsToUpdate.push({
                chk_num: orderListNew[n].checkdetails.chk_num,
                existing: false
            });
          }
        } else {
          orderItemsToUpdate.push({
              chk_num: orderListNew[n].checkdetails.chk_num,
              existing: false
          });

        }
      }

      this.refreshDelay = true;

      this.orderList = orderListNew;
      this.$forceUpdate();

      if (orderItemsToUpdate.length) {
        setTimeout(() => {
          for (let u=0; u < orderItemsToUpdate.length; u++) {
            if (orderItemsToUpdate[u].existing) {
              // existing order has been updated perfrom item list call right away
              this.updateOrderItems(orderItemsToUpdate[u].chk_num);
            }
            // reset size to 0, until order items api call returns
            this.resetSize({orderId: orderItemsToUpdate[u].chk_num, listContainer: {scrollHeight: 0, children: []}});
          }
        }, 10);
      }

      // reset the styling to defaults
      this.panelAnimation = [];
      this.panelShrink = [];
      this.panelFade = [];
      if (this.orderList && this.orderList.length) {
        for (let o=0; o < this.orderList.length; o++) {
          this.panelAnimation.push(true);
          this.panelShrink.push(false);
          this.panelFade.push(false);

          this.orderList[o].sortIndex = o;

          // create entry in hashMap for keeping track of existing orders if not already there
          if (!this.orderItemsHash[''+this.orderList[o].checkdetails.chk_num]) {
            this.orderItemsHash[''+this.orderList[o].checkdetails.chk_num] = {
              orderId: this.orderList[o].checkdetails.chk_num,
              orderObject: this.orderList[o]
            };
          } else {
            // refresh size of panel for existing orders
            this.resetSize(this.orderItemsHash[''+this.orderList[o].checkdetails.chk_num]);
          }
        }
      }
    },


    filterOutOrder(order) {
      // returns false if the order should be filtered out
      // for valid orders, returns true

      // check for ready flag
      if (this.readyOrdersDisplay) {
        // don't process not ready orders
        if (!order.checkdetails.readyTime) {
          return false;
        }
      } else {
        // don't process ready orders
        if (order.checkdetails.readyTime) {
          return false;
        }
      }

      // ignore anything in the order channel exclusion list
      const excludeList = api.appState.orderChannelExclusionList;
      if (excludeList && excludeList.length) {
        for (let e = 0; e < excludeList.length; e++) {
          if (checkFilterCriteria(excludeList[e].channel, order.checkdetails.last_name)
              && checkFilterCriteria(excludeList[e].type, order.checkdetails.name)) {

            // auto-bump order to remove it from future responses
            if (!api.useMockData && !api.useProxyApi) {
              this.bumpOrder(order);
            }

            return false;
          } 

          if (checkFilterCriteria(excludeList[e].emp_num, order.checkdetails.emp_num)
              && checkFilterCriteria(excludeList[e].type, order.checkdetails.name)) {

            return false;
          } 
        }
      }



      // ignore any ready orders beyond auto-bump time,
      // also auto-bump them
      if (this.readyOrdersDisplay) {
        const sOrderTime = order.checkdetails.readyTime;
        const dtOrderTime = formatting.dateFormat.dateFromStr(sOrderTime);
        const oElapsedTime = formatting.dateFormat.calcElapsedTime(dtOrderTime, this.currentTime);

        // check for auto-bump or expired orders
        if (this.checkAutoBump(order, oElapsedTime.totalMinutes)) {
          console.log('Auto-Bump: ' + order.checkdetails.chk_num + ' - ' + oElapsedTime.totalMinutes);

          // stagger bump calls
          setTimeout(() => {
            this.bumpOrder(order);
            this.autoBumpCount++;
          }, this.autoBumpCount * 500);

          return false;
        }
      }

      return true;
    },


    updateOrderItems(orderId) {
      const itemsObj = this.$refs['orderItems'+ orderId];
      if (itemsObj && itemsObj[0]) {

        // show loader
        this.setLoaderDisplay(orderId, true);

        itemsObj[0].getOrderItems();
      }
    },    


    checkAutoBump(order, minutes) {
      if (api.useMockData || api.useProxyApi) return false;
      
      if (!order.postPay && minutes >= api.appState.autoBumpMinutes) {
        return true;
      } else {
        return false;
      }
    },


    checkForPendingItemRefresh() {
      for (var o=0; o < this.orderList.length; o++) {
        if (this.$refs['orderItems'+ this.orderList[o].checkdetails.chk_num]
            && this.$refs['orderItems'+ this.orderList[o].checkdetails.chk_num][0]) {

          const orderItems = this.$refs['orderItems'+this.orderList[o].checkdetails.chk_num];
          if (orderItems[0].visibility == 'hidden') {
            return true;
          }
        }
      }

      return false;
    },

    initiateAppPush(orderTicket) {
      api.vmPushNotification(orderTicket, (success) => {
        if (success) {
          console.log('Push Notification sent');
          // add to exclusion list so it won't be sent again
          api.appState.pushNotificationList.push(orderTicket);
        } else {
          console.log('Push Notification failed');
        }
      });
    },

    bumpOrder(order, resultCallback) {
//      this.$parent.bumpSoundPlay(); 
      var self = this;
      let orderId = order.checkdetails.chk_num;

      // perform visual bump no matter what
      this.handleActionResponse();

      // perform bump api call
      console.log('Bump order: ' + orderId);
      var apiParameters = {};
      apiParameters.queryString = {};

      apiParameters.service = 'getBumpCheck'
      apiParameters.queryString['store_number'] = api.storeNumber;
      apiParameters.queryString['check_num'] = orderId;

      api.httpGet(apiParameters, function (response) {
        if (!response || response.data != 99) {
          console.log('Bump api call failed for order: ' + orderId);
        }

        // delete hashed record since bumped
        delete self.orderItemsHash[''+order.checkdetails.chk_num];

        if (typeof resultCallback === "function") {
          resultCallback(response);
        }
      });
    },

    readyOrder(order, resultCallback) {
    //  this.$parent.bumpSoundPlay(); 

      var self = this;
      let orderId = order.checkdetails.chk_num;

      // perform visual bump no matter what
      this.handleActionResponse();

      // perform bump api call
      console.log('Ready order: ' + orderId);
      var apiParameters = {};
      apiParameters.queryString = {};

      apiParameters.service = 'getReadyCheck'
      apiParameters.queryString['store_number'] = api.storeNumber;
      apiParameters.queryString['check_num'] = orderId;

      api.httpGet(apiParameters, function (response) {
        if (!response || response.data != 99) {
          console.log('Ready api call failed for order: ' + orderId);
        } else {
          if (self.orderItemsHash[''+order.checkdetails.chk_num]) {
            const orderTicket = self.orderItemsHash[''+order.checkdetails.chk_num].orderTicket;
          
            // initiate push request if it has not already been done for this order
            if (orderTicket && 
                api.appState.pushNotificationList.indexOf(orderTicket) == -1) 
            {
              self.initiateAppPush(orderTicket);
            }

            // delete hashed record since pushed
            delete self.orderItemsHash[''+order.checkdetails.chk_num];          
          }
        }

        if (typeof resultCallback === "function") {
          resultCallback(response);
        }
      });
    },

    recallOrder(order, resultCallback) {
    //  this.$parent.bumpSoundPlay(); 

      // perform recall api call
      console.log('Recall order:' + orderId);
      let orderId = order.checkdetails.chk_num;

      // perform visual bump no matter what
      this.handleActionResponse();

      var apiParameters = {};
      apiParameters.queryString = {};

      apiParameters.service = 'getRecallCheck'
      apiParameters.queryString['store_number'] = api.storeNumber;
      apiParameters.queryString['check_num'] = orderId;
      
      api.httpGet(apiParameters, function (response) {
        if (!response || response.data != 99) {
          console.log('Recalll api call failed for order: ' + orderId);
        }

        if (typeof resultCallback === "function") {
          resultCallback(response);
        }
      });
    },    


    actionLaunch(actionType) {
      if (this.pendingOrdersCall || this.checkForPendingItemRefresh()) return;
      
      this.actionInProgress = true;

      if (!this.selectedOrder) return;

      switch (actionType) {
        case 'bump' :
          this.bumpOrder(this.selectedOrder);
          break;
        case 'ready' :
          this.readyOrder(this.selectedOrder);
          break;
        case 'recall' :
          this.recallOrder(this.selectedOrder);
          break;
        default:
          console.warn('Wrong action parameter');
      }
    },
    

    handleActionResponse() {
        var self = this;
        if (!self.selectedOrder) return;

        var index = self.orderList.indexOf(self.selectedOrder);

        if (this.detailView) {
          // clear items in the bumped order for smoother looking animation
          self.$refs['orderItems'+ self.selectedOrder.checkdetails.chk_num][0].clearOrderItems();
        }

        // perform shrink animation
        self.panelShrink[index] = true;
        self.$forceUpdate();
        
        setTimeout(() => {
          // perform fade animation
          self.panelFade[index] = true;
          self.$forceUpdate();
        }, 200);

        setTimeout(() => {
          self.panelAnimation[index] = false;
          if (self.selectedOrder) {
            // bump order to recall list
            let i = self.orderList.indexOf(self.selectedOrder);
            self.orderList.splice(i,1);
            self.selectedOrder = null;
            self.$forceUpdate();
          }

          this.actionFinish();
        }, 400);
    },

    actionFinish() {
      this.$nextTick(()=> {
        this.panelAnimation = [];
        this.panelShrink = [];
        this.panelFade = [];

        // update UI to show remaining orders deselected
        this.orderList.forEach(order => {
          this.deselectOrder(order);
          this.panelAnimation.push(false);
          this.panelShrink.push(false);
          this.panelFade.push(false);
        });
      });

      // delay refresh of orders to let api calls catch up
      this.refreshDelay = false;
      setTimeout(() =>{
        this.refreshDelay = true;
        this.$forceUpdate();
      }, 5000);      

      // reset animation after .2 sec
      setTimeout(() => {
        for (let i = 0; i < this.panelAnimation.length; i++) {
          this.panelAnimation[i] = true;
        }

        this.$forceUpdate();
        // refresh open orders
        this.$nextTick(()=> {
          // refresh everything
          this.orderList = [];
          this.orderItemsHash = {};
          this.selectedOrder = null;

          this.getOpenOrders();

          if (this.$refs.orderSwiper) {
            this.$refs.orderSwiper.swiper.slideTo(0, 100, false);
          }

          this.actionButton = (this.readyOrdersDisplay || !this.showReady)
                            ? 'bump'
                            : 'ready';

          this.setDataPolling(true);

          this.actionInProgress = false;
        });
      },200);

      this.setDataPolling(false);
      this.$forceUpdate();

    },

    hideOrder(orderInfo) {
      for (var o=0; o < this.orderList.length; o++) {
        if (this.orderList[o].checkdetails.chk_num == orderInfo.orderId) {
          this.orderList[o].hidden = true;

          // auto-bump order to remove it from future responses
          if (!api.useMockData && !api.useProxyApi) {
            this.bumpOrder(this.orderList[o]);
          }
        }
      }
      this.$forceUpdate();
    },

    visibilityChanged (isVisible, entry) {
      if (isVisible) {
        this.updateOrderItems(entry.target.id);
      }
    },

    updateOrder(orderInfo) {
      // make a copy of the orderItems
      let orderObject = {};
      for (var o=0; o < this.orderList.length; o++) {
        if (this.orderList[o].checkdetails.chk_num == orderInfo.orderId) {
          //this.orderList[o].checkdetails.orderTicket = orderInfo.orderTicket;
          this.orderList[o].refId = orderInfo.refId || '';
          this.orderList[o].postPay = orderInfo.postPay || false;

          // hide orders that have been voided
          if (orderInfo.voided) {
            this.orderList[o].hidden = true;

            // auto-bump order to remove it from future responses
            if (!api.useMockData && !api.useProxyApi) {
              this.bumpOrder(this.orderList[o]);
            }
          } else {
            if (this.orderList[o].newOrder) {
              delete this.orderList[o].newOrder;
              this.$parent.orderSoundPlay();
            }

            orderObject = this.orderList[o];
          }

          this.$forceUpdate();

          break;
        }
      }

      if (orderInfo.updateHash) {
        this.orderItemsHash[''+orderInfo.orderId] = {
          orderId: orderInfo.orderId,
          orderObject: orderObject,
          items: orderInfo.processedItems,
          orderTicket: orderInfo.orderTicket,
          refId: orderInfo.refId,
          postPay: orderInfo.postPay,
          listContainer: orderInfo.listContainer
        };
      }

      // hide loader
      this.setLoaderDisplay(orderInfo.orderId,false);
      
      this.resetSize(orderInfo);
    },
    
    setLoaderDisplay(orderId, flag) {
      // hide or show loader animation
      const orderLoader = this.$refs['loader'+orderId];
      if (orderLoader && orderLoader[0]) {
        if (flag) {
          orderLoader[0].setAttribute('style','display:block');
        } else {
          orderLoader[0].setAttribute('style','display:none');
        }
      }
    },

    toggleOrderSelect(order) {
      if (this.readyOrdersDisplay) {
        // two phase selection
        if (this.selectedOrder == order && order.displayStatus == 'bump') {
          order.displayStatus = 'return';
          this.selectOrder(order, order.displayStatus);

          this.actionButton = 'return';
        } else if (this.selectedOrder == order && order.displayStatus == 'return') {
          order.displayStatus = 'ready';
          this.deselectOrder(order, order.displayStatus);

          this.actionButton = 'bump';
        } else {
          // deselect previous
          if (this.selectedOrder && this.selectedOrder.checkdetails.chk_num) {          
            this.deselectOrder(this.selectedOrder, 'ready');
          }
          order.displayStatus = 'bump';
          this.selectOrder(order, order.displayStatus);

          this.actionButton = 'bump';
        }
      } else {

        if (!this.showReady) {
          // single phase selection
          if (this.selectedOrder == order) {
            this.deselectOrder(this.selectedOrder, 'prep');
          } else {
            // deselect previous
            if (this.selectedOrder && this.selectedOrder.checkdetails.chk_num) {          
              this.deselectOrder(this.selectedOrder, 'prep');
            }

            this.actionButton = 'bump';
            this.selectOrder(order, 'ready');
          }
        } else {
          // two phase selection
          if (this.selectedOrder == order && order.displayStatus == 'ready') {
            order.displayStatus = 'bump';
            this.selectOrder(order, order.displayStatus);

            this.actionButton = 'bump';
          } else if (this.selectedOrder == order && order.displayStatus == 'bump') {
            order.displayStatus = 'prep';
            this.deselectOrder(order, order.displayStatus);

            this.actionButton = 'ready';
          } else {
            // deselect previous
            if (this.selectedOrder && this.selectedOrder.checkdetails.chk_num) {          
              this.deselectOrder(this.selectedOrder, 'prep');
            }
            order.displayStatus = 'ready';
            this.selectOrder(order, order.displayStatus);

            this.actionButton = 'ready';
          }
        }

      }
    },

    selectOrder(order, displayStatus) {
      if (!order || !order.checkdetails) return;

      this.setOrderDisplay(this.$refs['order' + order.checkdetails.chk_num][0], true, displayStatus);
      this.selectedOrder = order;
    },

    deselectOrder(order, displayStatus) {
      if (!order || !order.checkdetails) return;

      if (!displayStatus) {
        displayStatus = (this.readyOrdersDisplay)
                      ? 'ready'
                      : 'prep';
      }

      this.setOrderDisplay(this.$refs['order' + order.checkdetails.chk_num][0], false, displayStatus);
      this.selectedOrder = null;
    },

    setOrderDisplay(panel, selected, displayStatus) {
      if (!panel) return;

      // remove all available status styles intially
      panel.classList.remove('prep','ready','bump','return','selected');

      // reset styles based on parameters passed
      if (selected) {
        panel.classList.add('selected');
      }

      if (displayStatus) {
        if (!this.readyOrdersDisplay) {
          // flip colours on prep screen to match training
          if (displayStatus == 'ready') {
            displayStatus = 'bump';
          } else if (displayStatus == 'bump') {
            displayStatus = 'ready';
          }
        } 
        panel.classList.add(displayStatus);
      }
    },

    resetSize(orderInfo) {
      try {
        if (!this.detailView) return;

        const COL_WIDTH = 180;

        const orderPanel = this.$refs['order'+orderInfo.orderId][0];
        const slidePanel = this.$refs['slide'+orderInfo.orderId][0];

        const totalHeight = orderInfo.listContainer.scrollHeight;
        const orderMainItems = orderInfo.listContainer.children;

        let totalItemHeight = 0;
        let c = 1;
        for (var i=0; i<orderMainItems.length; i++) {
          totalItemHeight += orderMainItems[i].scrollHeight + 2;
          if (totalItemHeight > totalHeight) {
            c++;
            totalItemHeight = orderMainItems[i].scrollHeight;
          }
        }

        const h = window.innerHeight * 0.855;
        const w = 82 + (c * COL_WIDTH);

        if (orderPanel) {
          orderPanel.setAttribute('style','width:' + w + 'px; height:' + h +'px; border: 4px solid;');
        }
        if (slidePanel) {
          slidePanel.$el.setAttribute('style','width:' + w + 'px;');
        }

        this.$forceUpdate();
      } catch (err) {}
    },

    startElapsedTime() {
      if (this.elapsedTimeInterval) clearInterval(this.elapsedTimeInterval);
      this.elapsedTimeInterval = setInterval(() => {
        this.updateElapsedTime();
      }, 1000);
    },

    updateElapsedTime() {
      if (this.currentTime) {
        // add 1 second to current time counter
        this.currentTime.setSeconds(this.currentTime.getSeconds() + 1);

        // refresh page at 4:30am 
        if (this.currentTime.getHours() == 4
            && this.currentTime.getMinutes() == 30
            && this.currentTime.getSeconds() == 0) {
          this.reload();
        }

        if (this.orderList && this.orderList.length) {
          this.elapsedTime = [];
          for (var o=0; o < this.orderList.length; o++) {
            const sOrderTime = this.orderList[o].checkdetails[this.timeCheckField];
            const dtOrderTime = formatting.dateFormat.dateFromStr(sOrderTime);
            const oElapsedTime = formatting.dateFormat.calcElapsedTime(dtOrderTime, this.currentTime);

            this.elapsedTime.push(oElapsedTime);
          }
        }
      }
    },

    setDataPolling(flag, duration) {
      // set Order data refresh interval on/off based on flag passed
      if (flag) {
        if (this.pollingInterval) clearInterval(this.pollingInterval);
        console.log('Setting polling interval to: ' + duration);
        this.pollingInterval = setInterval(() => {
          if (!this.actionInProgress) {
            this.getOpenOrders();
          }
        }, duration || DEFAULT_POLLING_INTERVAL);
      } else {
        console.log('Stopped polling.');
        if (this.pollingInterval) clearInterval(this.pollingInterval);
      }
    },

    gotoKDSprep() {
  //    this.$parent.clickSoundPlay(); 

      this.refreshDelay = false;
      this.setDataPolling(false);

      // reset selected order
      this.deselectOrder(this.selectedOrder, 'ready');

      setTimeout(()=> {
        this.orderList = [];
        this.init();
      },200);

      router.push('/kdsPrep');
    },

    gotoKDSready() {
//      this.$parent.clickSoundPlay(); 

      this.refreshDelay = false;
      this.setDataPolling(false);

      // reset selected order
      this.deselectOrder(this.selectedOrder, 'prep');
      
      setTimeout(()=> {
        this.orderList = [];
        this.init();
      },200);

      router.push('/kdsReady');
    },

    gotoRecallList() {
//      this.$parent.clickSoundPlay(); 

      router.push('/recall');
    },

    reload() {
      location.reload(true);
    },

    toggleDetailView() {
      this.detailView = !this.detailView;
      api.kdsDetailView = this.detailView;

      api.saveState();
    },

    init(pollingInterval) {
      this.storeNumber = api.storeNumber;

      if (api.language_flag===null) {
        this.checkLanguage();
      } else {
        this.getOpenOrders();
      }

      if (this.selectedOrder) {
        this.deselectOrder(this.selectedOrder);
      }

      this.showReady = (api.brand == 'swiss'
                        || api.appState.showReadyOverrideList.indexOf(''+api.storeNumber) >= 0);

      if (this.readyOrdersDisplay) {
        this.actionButton = 'bump';
      } else if (!this.showReady) {
        this.actionButton = 'bump';
      } else {
        this.actionButton = 'ready'; 
      }
      
      this.orderItemsHash = {};
      this.setDataPolling(true, pollingInterval);

      // delay refresh of orders to let api calls catch up
      this.refreshDelay = false;
      setTimeout(() =>{
        this.refreshDelay = true;
        this.$forceUpdate();
      }, 10000);
    }

  },

  mounted: function(){
    console.log('KDS page');

    document.body.style.backgroundColor = "#000";

    // check stored state
    api.getState();
    api.setStore(api.storeNumber);

    // check query string for store number
    let storeId = getQueryStringParameterByName('storeId')
    if (storeId) {
      api.setStore(storeId);
    }

    if (api.storeSelected && api.storeNumber) {
      // fullstory id
      idFullStory(api.storeNumber);

      this.startElapsedTime();
      this.init();
    } else {
      if (process.env.ENABLE_WEB_LOGIN) {
        router.push('/login');
      } else {
        // check for storeId to be set on window by iOS app injection
        this.initInterval = setInterval(() => {
          if (window.config && window.config.storeId) {

            clearInterval(this.initInterval);

            api.setStore(window.config.storeId);
            api.setLanguage(window.config);
            api.setProxy(window.config);

            let pollingInterval = DEFAULT_POLLING_INTERVAL;

            // get the polling interval from iOS in seconds and set if in not in proxy mode
            if (!api.useProxyApi && window.config.refreshRate) {
              // set polling interval in milliseconds
              pollingInterval = 1000 * parseInt(window.config.refreshRate);
            }

            // fullstory id
            idFullStory(api.storeNumber);

            this.startElapsedTime();
            this.init(pollingInterval);
          }
        }, 500);
      }
    }

  },

  beforeDestroy() {
    if (this.pollingInterval) clearInterval(this.pollingInterval);
    if (this.initInterval) clearInterval(this.initInterval);
  },

  data() {
    return {
        orderList: [],
        pendingOrdersCall: false,
        selectedOrder: null,
        panelAnimation: [],
        panelShrink: [],
        panelFade: [],
        elapsedTime: [],
        actionButton: 'ready',
        currentTime: null,
        storeNumber: api.storeNumber,
        showReady: false,
        refreshDelay: false,
        detailView: api.kdsDetailView,
        swiperOption: {
          slidesPerView: 'auto',
          centeredSlides: false,
          preventClicks: false,
          preventClicksPropagation: false,
          spaceBetween: 5,
          allowTouchMove: false,
          slideToClickedSlide: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'progressbar'
          },
        
          navigation: {
            nextEl: '.button-next',
            prevEl: '.button-prev',
            disabledClass: 'invisible',
            hiddenClass: 'invisible'

          }
        },
        swiperOptionDetailless: {
          slidesPerView:6,
          slidesPerColumn:3,
          spaceBetween: 5,
          direction: 'horizontal',
          slidesPerColumnFill: 'column',
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'progressbar'
          },          
          navigation: {
            nextEl: '.button-next',
            prevEl: '.button-prev',
            disabledClass: 'invisible',
            hiddenClass: 'invisible'
          }          
        },        
        error: '...'
    }
  }

}

</script>

<template>
<div>
  <div class="row" style="color: white; margin: 0px;">
    <div class="pull-left" 
     style="color: white; 
            font-size: larger; 
            font-weight: bold; 
          "
    >
      <span v-if="readyOrdersDisplay" style="color: gold;">KDS - Ready for Pickup</span>
      <span v-else style="color: #caffc4;">KDS - Need Preparation</span>
      <button type="button" 
        class="btn btn-default"  
        @click="toggleDetailView()"
        style="margin: 2px 7px 1px 7px;
               width: 2.5em;
               font-weight: bolder;
               background-color: floralwhite;
               color: darkred;
              "
      >{{(detailView) ? '-' : '+'}}</button> 
    </div>
    <div class="pull-right">{{$t('store_number')}}: <b>{{storeNumber}}</b></div>
  </div>
  <div v-show="refreshDelay">
    <div v-if="orderList && orderList.length" class="row" style="height:87%;position: fixed;width:100%;">
      <div v-if="detailView" class="col-sm-12">
        <swiper ref="orderSwiper"
         :options="swiperOption"
         class="panel-trans"
         style="height:100%; padding-top: 5px;"
        >
            <slide v-for="order, index in orderList" v-if="!order.hidden" :ref="'slide' + order.checkdetails.chk_num" > 
                <div :ref="'order' + order.checkdetails.chk_num"
                  :id="order.checkdetails.chk_num" 
                  @click="toggleOrderSelect(order)"
                  style="width: 230px;"
                  :class="{'panel': true,
                          'panel-default': true,
                          'box-shadow': true,
                          'ready': readyOrdersDisplay,
                          'panel-trans': panelAnimation[index],
                          'panel-shrinking': panelShrink[index],
                          'panel-fade': panelFade[index]
                        }"
                  v-observe-visibility="{
                    callback: visibilityChanged,
                    once: true,
                  }"                        
                >
                  <orderheader 
                  class="panel-heading"
                  :checkNum="order.checkdetails.chk_num"
                  :revenueType="order.checkdetails.name"
                  :firstName="order.checkdetails.first_name"
                  :lastName="order.checkdetails.last_name"
                  :time="(elapsedTime[index]) ? elapsedTime[index].time : ''"
                  :timeColour="(elapsedTime[index]) ? elapsedTime[index].colour : ''"
                  :postPay="order.postPay"
                  :closedDate="order.checkdetails.chk_clsd_date_time"
                  />
                  <div class="panel-body" style="height:80%; width: 100%;">
                    <div :ref="'loader'+order.checkdetails.chk_num" 
                      class="loader"
                      style="display:none;"
                    ></div>

                    <orderitems :ref="'orderItems'+order.checkdetails.chk_num" 
                      :orderId="parseInt(order.checkdetails.chk_num)" 
                      :customerName="order.checkdetails.id"
                      @updateOrder="updateOrder"
                      @hideOrder="hideOrder"
                    />
                  </div>
                </div>
            </slide>
            
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
      </div>
      <div v-else>
        <div style="margin: 5px;" >
          <swiper :options="swiperOptionDetailless"
            class="panel-trans"
            style="height: 95%; width: 100%; padding: 10px 0px;"
          >
            <slide v-for="order, index in orderList" 
            style="height: 25vh;"
            > 
              <div :ref="'order' + order.checkdetails.chk_num"
                  :id="order.checkdetails.chk_num" 
                  @click="toggleOrderSelect(order)"
                  :class="{'panel': true,
                          'panel-default': true,
                          'box-shadow': true,
                          'ready': readyOrdersDisplay,
                          'panel-trans': panelAnimation[index],
                          'panel-shrinking': panelShrink[index],
                          'panel-fade': panelFade[index]
                        }"
                  style="margin: 0px; padding: 0px; height: 24vh;"
                name="panel"
                >
                  <orderheader 
                    class="panel-heading"
                    style="height: 100%;"
                    :checkNum="order.checkdetails.chk_num"
                    :revenueType="order.checkdetails.name"
                    :firstName="order.checkdetails.first_name"
                    :lastName="order.checkdetails.last_name"
                    :time="(elapsedTime[index]) ? elapsedTime[index].time : ''"
                    :timeColour="(elapsedTime[index]) ? elapsedTime[index].colour : ''"
                    :postPay="order.postPay"
                    :closedDate="order.checkdetails.chk_clsd_date_time"
                    :recallDisplay="true"
                    :id="order.checkdetails.id"
                  />
                  
                </div>
            </slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>      
    </div>
    <div v-else class="row" style="height:87%;position: fixed;width:100%; text-align:center;">
      <h3 v-if="error" style="color: white; margin: 20px;">
        {{error}}
      </h3>
      <h3 v-else style="color: white; margin: 20px;">
        {{$t('no_orders')}}
      </h3>
    </div>
  </div>
  <div v-show="!refreshDelay" class="row" style="height:87%;position: fixed;width:100%; text-align:center;">
    <h3 style="color: white; margin: 20px;">
        {{$t('loading')}}...
    </h3>
  </div>
  
  <div class="row" 
   style="position:fixed;
          bottom:5px;
          margin: 0px 0px -4px -1px;
          width:100%;
          z-index:20">
    <table style="width:100%; ">
        <tr>
              <td style="padding:0px 20px 0px 0px">
                <button v-if="readyOrdersDisplay"
                  @click="gotoKDSprep()"
                  class="btn btn-lg btn-block" 
                  style="height: 60px; width: 185px;  background-color: white;"
                  ><i 
                  class="fas fa-arrow-left pull-left"
                  style="margin: 2px 5px 0px 0px;"
                  ></i>Go to Prep
                </button>
                <button v-else-if="showReady"
                  @click="gotoKDSready()"
                  class="btn btn-lg btn-block " 
                  style="height: 60px; width: 185px;  background-color: gold;"
                  ><i 
                  class="fas fa-arrow-right pull-left"
                  style="margin: 2px 10px 0px 0px;"
                  ></i>Go to Ready
                </button>
              </td>
              <td style="padding:0px 10px;">
                <div v-if="orderList && orderList.length" 
                      class="btn btn-block btn-lg btn-default button-prev btn-modified pull-right" 
                      style="width: 120px; background-color: #00ffff;"
                      slot="button-prev"
                      
                      @click="deselectOrder(selectedOrder)"
                      ><i class="fas fa-chevron-left"></i> {{$t('prev')}}
                </div>
             </td> 
             <td>
                <button v-if="actionButton == 'bump'" 
                  @click="actionLaunch('bump')"
                  class="btn btn-block btn-lg btn-success"
                  :style="'height: 60px; width: 100%;'
                          + ((readyOrdersDisplay || !showReady) ? '' : 'background-color: darkorange;')"
                  :disabled="!selectedOrder"
                  ><i 
                  class="fas fa-external-link-alt pull-left"
                  style="margin: 2px 0px 0px 0px;"
                  ></i>{{$t('bump_order')}}
                </button>
                <button v-else-if="actionButton == 'ready'" 
                  @click="actionLaunch('ready')"
                  class="btn btn-block btn-lg btn-success"
                  style="height: 60px; width: 100%;"
                  :disabled="!selectedOrder"
                  ><i 
                  class="fas fa-external-link-alt pull-left"
                  style="margin: 2px 10px 0px 0px;"
                  ></i>Mark as Ready
                </button>
                <button v-else-if="actionButton == 'return'" 
                  @click="actionLaunch('recall')"
                  class="btn btn-block btn-lg btn-success"
                  style="height: 60px; width: 100%; background-color: darkorange"
                  :disabled="!selectedOrder"
                  ><i 
                  class="fas fa-history pull-left"
                  style="margin: 2px 10px 0px 0px;"
                  ></i>Return To Prep
                </button>
             </td>  
             <td style="padding:0px 10px;">
                <div v-if="orderList && orderList.length" 
                    class="btn btn-block btn-lg  btn-default button-next btn-modified" 
                    style="width: 120px; background-color: #00ffff;"
                    slot="button-next"
                    @click="deselectOrder(selectedOrder)"
                    >{{$t('next')}} <i class="fas fa-chevron-right"></i>
                </div>
             </td>  
             <td style="padding: 0px 20px 0px 0px;">
                <button 
                  @click="gotoRecallList()"
                  class="btn btn-lg btn-block btn-danger pull-right" 
                  style="height: 60px; width: 180px; margin: 5px"
                  ><i 
                  class="fas fa-history pull-left"
                  style="margin: 2px 5px 0px 0px;"
                  ></i>Go to Recall
                </button>
             </td>               
         </tr> 
    </table> 
    
  </div>
</div>
</template>

<style scoped>

.selected {
  border:solid 3px #ff0000 !important;
}

.bump {
  background: #caffc4
}
.bump .panel-heading {
  background: #9ec7a9;
}

.ready {
  background:khaki;
}
.ready .panel-heading {
  background: gold;
}

.return {
  background: rgb(225, 176, 90);
}
.return .panel-heading {
  background: orange;
}

.prep {
  background:white;
}
.prep .panel-heading {
  background: #ddd;
}

</style>


// WEBPACK FOOTER //
// KdsDisplay.vue?9f438dd2